import React, { FC, useEffect, useState } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { ShopEditAccountTemplate } from 'components/Templates'
import { fetchShop } from 'reducks/shop/operations'
import { getShopName } from 'reducks/shop/selectors'

const ShopEditAccount: FC = () => {
  const dispatch = useDispatch()

  const name = useSelector((state: State) => getShopName(state))
  const path = useSelector((state: State) => state.router.location.pathname)
  const isCreatePage = /\/admin\/shops\/create\/account/.test(path)
  const id = isCreatePage
    ? undefined
    : path.split('/admin/shops/')[1]
    ? path.split('/admin/shops/')[1].split('/account')[0]
    : undefined

  useEffect(() => {
    if (!id) return
    dispatch(fetchShop(id))
  }, [])

  return (
    <Layout
      headline={isCreatePage ? '新規店舗作成' : undefined}
      title={isCreatePage ? '新規店舗アカウント情報の設定' : `${name}の店舗アカウント情報の設定`}
    >
      <ShopEditAccountTemplate isCreatePage={isCreatePage} isEditedByOwner={false} shopId={id} />
    </Layout>
  )
}

export default ShopEditAccount
